import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const VideoCheckOutlineIcon: React.FC<OneColorIconProps> = ({ color = 'white', size = 16, className }) => {
  const c1 = getHexColor(color)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={c1}
      viewBox="0 0 24 24"
      height={size}
      width={size}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68668 9C3.53896 9 3.40047 8.97748 3.27121 8.93243C3.14196 8.88739 3.02193 8.81081 2.91114 8.7027L1.33237 7.16216C1.11079 6.94595 1 6.68919 1 6.39189C1 6.09459 1.11079 5.84685 1.33237 5.64865C1.53549 5.43243 1.794 5.32432 2.10791 5.32432C2.42182 5.32432 2.68033 5.42342 2.88345 5.62162L3.68668 6.40541L6.81653 3.32432C7.03811 3.10811 7.29662 3 7.59206 3C7.88751 3 8.15525 3.10811 8.3953 3.32432C8.59841 3.54054 8.69997 3.8018 8.69997 4.10811C8.69997 4.41441 8.59841 4.66667 8.3953 4.86486L4.46222 8.7027C4.35143 8.81081 4.2314 8.88739 4.10215 8.93243C3.97289 8.97748 3.8344 9 3.68668 9ZM14.1522 8.76269H7.46011L9.24993 6.99998H14.1522C15.1669 6.99998 16.1401 7.37141 16.8576 8.03255C17.5751 8.6937 17.9783 9.5904 17.9783 10.5254V10.6592L21.5689 8.76861C21.865 8.61273 22.2287 8.61385 22.5236 8.77155C22.8185 8.92924 23 9.21966 23 9.53384V17.466C23 17.7802 22.8185 18.0706 22.5236 18.2283C22.2287 18.386 21.865 18.3872 21.5689 18.2313L17.9783 16.3407V18.4576C17.9783 18.8667 17.8019 19.259 17.488 19.5482C17.1741 19.8375 16.7483 20 16.3043 20H4.82609C3.81134 20 2.83816 19.6286 2.12063 18.9674C1.4031 18.3063 1 17.4096 1 16.4746V9.70823L2.91304 11.5923V16.4746C2.91304 16.9421 3.11459 17.3904 3.47336 17.721C3.83212 18.0516 4.31872 18.2373 4.82609 18.2373H16.0652V14.8366C16.065 14.8263 16.065 14.816 16.0652 14.8057V12.1942C16.065 12.1839 16.065 12.1736 16.0652 12.1633V10.5254C16.0652 10.0579 15.8637 9.60955 15.5049 9.27898C15.1461 8.94841 14.6595 8.76269 14.1522 8.76269ZM17.9783 14.3105V12.6894L21.087 11.0526V15.9473L17.9783 14.3105Z"
        />
      </g>
    </svg>
  )
}
